<template>
	<div class="p-3">
		<div class="row">
            <div class="col-md-12">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div class="row">
                        <div class="col-md-12 text-center">
                            <h5>TARGET  VS  PENCAPAIAN</h5>
                        </div>
                    </div>
                    <hr style="margin-top:5px;background-color: #B2B5BC;">
                    <div class="row">
						<div class="col-md-3">
                            <div class="text-center"><h6>OVER ALL</h6></div>
                            <BarChart v-loading.body="loading.overall" :data="chartdataoverall" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
                        <div class="col-md-4">
                            <div class="text-center"><h6>PER SALES AREA</h6></div>
                            <BarChart v-loading.body="loading.bysalesarea" :data="chartdatapersalesarea" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
                        <div class="col-md-5">
                            <div class="text-center"><h6>PER KATEGORI</h6></div>
                            <BarChart v-loading.body="loading.bycategory" :data="chartdataperkategori" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
					</div>
				</el-card>	
			</div>
		</div>

		<div class="row">
			<div class="col-md-12">
				<el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div class="row">
                        <div class="col-md-12 text-center">
                            <h5>DETAIL PENCAPAIAN PER KATEGORI PER SALES AREA</h5>
                        </div>
                    </div>
                    <hr style="margin-top:5px;background-color: #B2B5BC;">
                    <div class="row">
						<div class="col-md-4 mb-4">
                            <div class="text-center">
                                <h6>SALES AREA 1 &nbsp;&nbsp;<el-tag key="label1" type="success" effect="plain" size="small">{{ formatNum(this.percentage.salesarea1) }}%</el-tag></h6>                                 
                            </div>
                            <BarChart v-loading.body="loading.bycategoryandsalesarea1" :data="chartdatasalesarea1" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="text-center"><h6>SALES AREA 2 &nbsp;&nbsp;<el-tag key="label1" type="success" effect="plain" size="small">{{ formatNum(this.percentage.salesarea2) }}%</el-tag></h6></div>
                            <BarChart v-loading.body="loading.bycategoryandsalesarea2" :data="chartdatasalesarea2" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="text-center"><h6>SALES AREA 3 &nbsp;&nbsp;<el-tag key="label1" type="success" effect="plain" size="small">{{ formatNum(this.percentage.salesarea3) }}%</el-tag></h6></div>
                            <BarChart v-loading.body="loading.bycategoryandsalesarea3" :data="chartdatasalesarea3" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="text-center"><h6>SALES AREA 4 &nbsp;&nbsp;<el-tag key="label1" type="success" effect="plain" size="small">{{ formatNum(this.percentage.salesarea4) }}%</el-tag></h6></div>
                            <BarChart v-loading.body="loading.bycategoryandsalesarea4" :data="chartdatasalesarea4" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="text-center"><h6>SALES AREA 5 &nbsp;&nbsp;<el-tag key="label1" type="success" effect="plain" size="small">{{ formatNum(this.percentage.salesarea5) }}%</el-tag></h6></div>
                            <BarChart v-loading.body="loading.bycategoryandsalesarea5" :data="chartdatasalesarea5" :width="500" :height="300" style="margin-top: -20px;"/>
                        </div>
					</div>
				</el-card>	
			</div>
		</div> 

        <div class="row">
            <div class="col-md-12">
                <el-card class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '0px', paddingRight: '0px' }">
					<div class="row">
                        <div class="col-md-12 text-center">
                            <h5>PROGRESS</h5>
                        </div>
                    </div>
                    <hr style="margin-top:5px;background-color: #B2B5BC;">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h6>DETAIL PROGRESS PER AKTIFITAS </h6>
                        </div>
                        <div class="col-md-12 pl-3 pr-3" style="margin-top:-10px;">
                            <ReportResultTable reportname="SinergiReport" :reportdata="reportdata" :reporturl="''" :loading="loading.registercustomer" />
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
		
    </div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import Loader from '@/components/loader/Loader.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import {Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'

export default
{
	extends:Customer,
	components: {
        BarChart,
		ReportResultTable,
		//Loader,
	},
	computed:{
	},
    data() {
      return {
        chartdata: [],
        tabIndex:this.$route.query.tab, 
		status : this.$route.query.status ? this.$route.query.status : '',
		rekap : this.$route.query.rekap ? this.$route.query.rekap : '',
        urlRequestParams: '',

        loading: {
            table: false,
            chart: false,
            overall: false,
            bysalesarea: false,
            bycategory: false,
            bycategoryandsalesarea1: false,
            bycategoryandsalesarea2: false,
            bycategoryandsalesarea3: false,
            bycategoryandsalesarea4: false,
            bycategoryandsalesarea5: false,
            registercustomer: false,
        },

        year: Penanggalan().tahun,

        chartdataoverall: [],
        chartdatapersalesarea: [],
        chartdataperkategori: [],

        chartdatasalesarea1: [],
        chartdatasalesarea2: [],
        chartdatasalesarea3: [],
        chartdatasalesarea4: [],
        chartdatasalesarea5: [],

        percentage: {
            salesarea1: '0',
            salesarea2: '0',
            salesarea3: '0',
            salesarea4: '0',
            salesarea5: '0',
        },

        reportdata: [],
        
        /*
        reportdata:{
            data: [
                {
                    SalesArea: 'SA 1',
                    Target: '24',
                    Visit: '23',
                    Registrasi: '23',
                    ReqNoVa: '23',
                    DataPelanggan: '23',
                    Sae: '23',
                    ApprovalSam: '23',
                    EContract : '24',
                },
                {
                    SalesArea: 'SA 2',
                    Target: '24',
                    Visit: '23',
                    Registrasi: '23',
                    ReqNoVa: '23',
                    DataPelanggan: '23',
                    Sae: '23',
                    ApprovalSam: '23',
                    EContract : '24',
                },
                {
                    SalesArea: 'SA 3',
                    Target: '24',
                    Visit: '23',
                    Registrasi: '23',
                    ReqNoVa: '23',
                    DataPelanggan: '23',
                    Sae: '23',
                    ApprovalSam: '23',
                    EContract : '24',
                },
                {
                    SalesArea: 'SA 4',
                    Target: '24',
                    Visit: '23',
                    Registrasi: '23',
                    ReqNoVa: '23',
                    DataPelanggan: '23',
                    Sae: '23',
                    ApprovalSam: '23',
                    EContract : '24',
                },
                {
                    SalesArea: 'SA 5',
                    Target: '24',
                    Visit: '23',
                    Registrasi: '23',
                    ReqNoVa: '23',
                    DataPelanggan: '23',
                    Sae: '23',
                    ApprovalSam: '23',
                    EContract : '24',
                },
            ],

            columns: [
                {
                    title: 'Sales Area',
                    field: 'SalesArea',
                    format: '',
                },
                {
                    title: 'Target',
                    field: 'Target',
                    format: '',
                },
                {
                    title: 'Visit/Surat Penawaran/Proposal',
                    field: 'Visit',
                    format: '',
                },
                {
                    title: 'Registrasi (ID Pelanggan)',
                    field: 'Registrasi',
                    format: '',
                },
                {
                    title: 'Req. No. VA',
                    field: 'ReqNoVa',
                    format: '',
                },
                {
                    title: 'Input Data Pelanggan',
                    field: 'DataPelanggan',
                    format: '',
                },
                {
                    title: 'Verifikasi SAE',
                    field: 'Sae',
                    format: '',
                },
                {
                    title: 'Approval SAM',
                    field: 'ApprovalSam',
                    format: '',
                },
                {
                    title: 'E-Contract',
                    field: 'EContract',
                    format: '',
                },
            ]
        },
        */
        chartdataoverallSample: [
            {
                label: 'OVER ALL',
                legend: 'Target',
                valuecol: 172,
            },
            {
                label: 'OVER ALL',
                legend: 'Pencapaian',
                valuecol: 144,
            },
        ],

        chartdatapersalesareaSample: [
            {
                label: 'SA 1',
                legend: 'Target',
                valuecol: 24,
            },
            {
                label: 'SA 1',
                legend: 'Pencapaian',
                valuecol: 24,
            },
            {
                label: 'SA 2',
                legend: 'Target',
                valuecol: 58,
            },
            {
                label: 'SA 2',
                legend: 'Pencapaian',
                valuecol: 57,
            },
            {
                label: 'SA 3',
                legend: 'Target',
                valuecol: 17,
            },
            {
                label: 'SA 3',
                legend: 'Pencapaian',
                valuecol: 16,
            },
            {
                label: 'SA 4',
                legend: 'Target',
                valuecol: 48,
            },
            {
                label: 'SA 4',
                legend: 'Pencapaian',
                valuecol: 43,
            },
            {
                label: 'SA 5',
                legend: 'Target',
                valuecol: 25,
            },
            {
                label: 'SA 5',
                legend: 'Pencapaian',
                valuecol: 24,
            },
        ],

        chartdataperkategoriSample: [
            {
                label: 'Pertamina',
                legend: 'Target',
                valuecol: 7,
            },
            {
                label: 'Pertamina',
                legend: 'Pencapaian',
                valuecol: 5,
            },

            {
                label: 'BUMN',
                legend: 'Target',
                valuecol: 61,
            },
            {
                label: 'BUMN',
                legend: 'Pencapaian',
                valuecol: 61,
            },

            {
                label: 'BUMD',
                legend: 'Target',
                valuecol: 3,
            },
            {
                label: 'BUMD',
                legend: 'Pencapaian',
                valuecol: 3,
            },

            {
                label: 'Swasta',
                legend: 'Target',
                valuecol: 64,
            },
            {
                label: 'Swasta',
                legend: 'Pencapaian',
                valuecol: 61,
            },

            {
                label: 'Pemerintah',
                legend: 'Target',
                valuecol: 36,
            },
            {
                label: 'Pemerintah',
                legend: 'Pencapaian',
                valuecol: 33,
            },          
        ],

        chartdatasalesarea1Sample: [
            {
                label: 'Pertamina Group',
                legend: 'Target',
                valuecol: 3,
            },
            {
                label: 'Pertamina Group',
                legend: 'Pencapaian',
                valuecol: 3,
            },

            {
                label: 'BUMN',
                legend: 'Target',
                valuecol: 15,
            },
            {
                label: 'BUMN',
                legend: 'Pencapaian',
                valuecol: 15,
            },

            {
                label: 'BUMD',
                legend: 'Target',
                valuecol: 0,
            },
            {
                label: 'BUMD',
                legend: 'Pencapaian',
                valuecol: 0,
            },

            {
                label: 'Swasta',
                legend: 'Target',
                valuecol: 4,
            },
            {
                label: 'Swasta',
                legend: 'Pencapaian',
                valuecol: 4,
            },

            {
                label: 'Instansi Pemerintah',
                legend: 'Target',
                valuecol: 2,
            },
            {
                label: 'Instansi Pemerintah',
                legend: 'Pencapaian',
                valuecol: 2,
            },  
        ],

        chartdatasalesarea2Sample: [
        {
                label: 'Pertamina Group',
                legend: 'Target',
                valuecol: 2,
            },
            {
                label: 'Pertamina Group',
                legend: 'Pencapaian',
                valuecol: 1,
            },

            {
                label: 'BUMN',
                legend: 'Target',
                valuecol: 14,
            },
            {
                label: 'BUMN',
                legend: 'Pencapaian',
                valuecol: 14,
            },

            {
                label: 'BUMD',
                legend: 'Target',
                valuecol: 2,
            },
            {
                label: 'BUMD',
                legend: 'Pencapaian',
                valuecol: 2,
            },

            {
                label: 'Swasta',
                legend: 'Target',
                valuecol: 26,
            },
            {
                label: 'Swasta',
                legend: 'Pencapaian',
                valuecol: 26,
            },

            {
                label: 'Instansi Pemerintah',
                legend: 'Target',
                valuecol: 13,
            },
            {
                label: 'Instansi Pemerintah',
                legend: 'Pencapaian',
                valuecol: 13,
            },  
        ],

        chartdatasalesarea3Sample: [
        {
                label: 'Pertamina Group',
                legend: 'Target',
                valuecol: 1,
            },
            {
                label: 'Pertamina Group',
                legend: 'Pencapaian',
                valuecol: 1,
            },

            {
                label: 'BUMN',
                legend: 'Target',
                valuecol: 4,
            },
            {
                label: 'BUMN',
                legend: 'Pencapaian',
                valuecol: 4,
            },

            {
                label: 'BUMD',
                legend: 'Target',
                valuecol: 0,
            },
            {
                label: 'BUMD',
                legend: 'Pencapaian',
                valuecol: 0,
            },

            {
                label: 'Swasta',
                legend: 'Target',
                valuecol: 7,
            },
            {
                label: 'Swasta',
                legend: 'Pencapaian',
                valuecol: 7,
            },

            {
                label: 'Instansi Pemerintah',
                legend: 'Target',
                valuecol: 5,
            },
            {
                label: 'Instansi Pemerintah',
                legend: 'Pencapaian',
                valuecol: 4,
            },  
        ],

      }
    },

	watch:
	{
		
	},      
	mounted(){
        this.$emit('childrenRoute')		
		//this.resumePilihan()
        //this.setChart()
        this.getSalesOverall()
        this.getSalesByArea()
        this.getSalesByCategory()
        this.getSalesByCategoryAndSalesArea1()
        this.getSalesByCategoryAndSalesArea2()
        this.getSalesByCategoryAndSalesArea3()
        this.getSalesByCategoryAndSalesArea4()
        this.getSalesByCategoryAndSalesArea5()
        this.getCustomerRegisterProgress()
    },
    methods:{
        resumePilihan(){
            this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/customer/complaint135?'
			else if (this.tabIndex == 1) this.urlRequestParams+='/customer/complaintspbu?'
            this.urlRequestParams+='&date-range-start='+this.date.Start
            this.urlRequestParams+='&date-range-end='+this.date.End
            this.urlRequestParams+='&status='+this.status
            this.urlRequestParams+='&rekap='+this.rekap

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                //this.reportdata = response.data;

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})

        },

        getSalesOverall() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-overall?'
            this.urlRequestParams+='&year='+this.year

			this.loading.overall = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.chartdataoverall = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.overall = false;
			})

        },

        getSalesByArea(){
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-area?'
            this.urlRequestParams+='&year='+this.year

			this.loading.bysalesarea = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.chartdatapersalesarea = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bysalesarea = false;
			})

        },

        getSalesByCategory() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-customer-category?'
            this.urlRequestParams+='&year='+this.year

			this.loading.bycategory = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.chartdataperkategori = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bycategory = false;
			})

        },

        getSalesByCategoryAndSalesArea1() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-customer-category-area?'
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area=1'

			this.loading.bycategoryandsalesarea1 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.percentage.salesarea1 = response.data.percentage_value;
                this.chartdatasalesarea1 = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bycategoryandsalesarea1 = false;
			})

        },

        getSalesByCategoryAndSalesArea2() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-customer-category-area?'
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area=2'

			this.loading.bycategoryandsalesarea2 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.percentage.salesarea2 = response.data.percentage_value;
                this.chartdatasalesarea2 = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bycategoryandsalesarea2 = false;
			})

        },

        getSalesByCategoryAndSalesArea3() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-customer-category-area?'
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area=3'

			this.loading.bycategoryandsalesarea3 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.percentage.salesarea3 = response.data.percentage_value;
                this.chartdatasalesarea3 = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bycategoryandsalesarea3 = false;
			})

        },

        getSalesByCategoryAndSalesArea4() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-customer-category-area?'
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area=4'

			this.loading.bycategoryandsalesarea4 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.percentage.salesarea4 = response.data.percentage_value;
                this.chartdatasalesarea4 = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bycategoryandsalesarea4 = false;
			})

        },

        getSalesByCategoryAndSalesArea5() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/sales-by-customer-category-area?'
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area=5'

			this.loading.bycategoryandsalesarea5 = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                let responseData = response.data.data;
                this.percentage.salesarea5 = response.data.percentage_value;
                this.chartdatasalesarea5 = this.processBarChart(responseData, "legend", "", "value", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.bycategoryandsalesarea5 = false;
			})

        },

        getCustomerRegisterProgress() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/sinergi/register-customer?'
            this.urlRequestParams+='&year='+this.year

			this.loading.registercustomer = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.registercustomer = false;
			})

        },

        setChart() {
            this.chartdataoverall = this.processBarChart(this.chartdataoverallSample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatapersalesarea = this.processBarChart(this.chartdatapersalesareaSample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdataperkategori = this.processBarChart(this.chartdataperkategoriSample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);

            this.chartdatasalesarea1 = this.processBarChart(this.chartdatasalesarea1Sample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatasalesarea2 = this.processBarChart(this.chartdatasalesarea2Sample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
            this.chartdatasalesarea3 = this.processBarChart(this.chartdatasalesarea3Sample, "legend", "", "valuecol", false, "label", "", 1, 2, Rainbow, false, false, false, false);
        },


    }
}
</script>
<style>


</style>